import AppDispatcher from '../utils/AppDispatcher';
import AjaxPromises from '../utils/AjaxPromises';
import * as _ from 'lodash';

import { actions as ActionTypes } from '../constants/PosCartConstants';
import PosCartApi from '../api/PosCartApi';

import NotificationActions from './NotificationActions';
import PosActions from './PosActions';
import PrintActions from './PrintActions';
import GuestActions from './GuestActions';
import { endPoints as CartEndPoints } from '../constants/PosCartConstants';

import UserStore from '../stores/UserStore';
import PosStore from '../stores/PosStore';
import PosCartStore from '../stores/PosCartStore';
import GuestStore from '../stores/GuestStore';

let PosCartActions = {
    clearCartDisplay:() => {
        AjaxPromises.POST(CartEndPoints.CLEAR_CART_DISPLAY, UserStore.getApiData());
    },
    loadUserCart:(guest_id, shipment_id) => {
        let formData        = UserStore.getApiData();
        formData.AcctId     = guest_id;
        formData.ShipmentId = shipment_id;
        formData.Timestamp = +new Date();
        formData.UpdateCache = UserStore.getState().selectedLocation.UseCartDisplay;

        return AjaxPromises.POST(CartEndPoints.LOAD_CART, formData).then(resp => {
            if(!resp.Result) {
                console.error(resp);
                NotificationActions.error('Error loading cart');
                return;
            }
            let data = resp.Data;

            let selectedGuest = GuestStore.selectedGuestId();
            if(selectedGuest != guest_id) {
                return;
            }

            if (data.Cart) {
                _.each(data.Cart, i => {
                    i.uuid = i.SerialNo.replace(/[^a-zA-Z0-9]/g, '-')+i.Id;
                });
            }

            if (data.PreOrders) {
                _.each(data.PreOrders, i => {
                    i.uuid = i.SerialNo.replace(/[^a-zA-Z0-9]/g, '-')+i.Id;
                });
            }

            let allotment = {};
            let hasCannabisItemInCart = (data.Cart).some(cartItem => cartItem.CannbisProduct === 'Yes')
            let usingDaysSupply = UserStore.getState().selectedLocation.ShowDaysSupplyCalculator
            if(!usingDaysSupply) {
                if(data.Allotment && data.Allotment.Error) {
                    NotificationActions.error('Error loading allotment: \n' + data.Allotment.ErrorMessage);
                }
                else {
                    allotment = data.Allotment || {};
                    if (hasCannabisItemInCart && allotment.TotalRemaining < 0) {
                        NotificationActions.warn(`Patient allotment exceeded by ${Math.abs(allotment.TotalRemaining)}g.`)
                    }
                }
            } else {
                let daysSupplyInCart = (data.Cart).reduce((value, cartItem) => value + cartItem.QtySelected * (cartItem.DaysSupply !== "" ? parseFloat(cartItem.DaysSupply) : 0), 0.00);
                let daysSupplyRemaining = GuestStore.getState().guest.find(x => x.Guest_id == guest_id).DaysSupplyRemaining;
                
                if(Number.isFinite(daysSupplyInCart) && Number.isFinite(daysSupplyRemaining)) {
                    if(daysSupplyInCart > daysSupplyRemaining) {
                        NotificationActions.warn(`Patient days supply exceeded by ${Math.abs(daysSupplyInCart - daysSupplyRemaining)}.`);
                    }
                }
            }

            AppDispatcher.dispatch({
                actionType: ActionTypes.USER_CART_LOADED,
                cart: data.Cart || [],
                preOrders: data.PreOrders || [],
                appliedDiscounts: data.Discounts || [],
                appliedFeesDonations: data.FeesDonations || [],
                allotment,
                loyalty: data.Loyalty ? data.Loyalty.AppliedLoyaltyPoints : 0,
                timestamp: data.Timestamp,
                payment: data.Payment ? data.Payment : { ElectronicAmount: null, ElectronicType: null },
                SubTotal: data.SubTotal,
                TotalDiscountAndLoyalty: data.TotalDiscountAndLoyalty,
                Tax: data.Tax,
                FeesAndDonations: data.FeesAndDonations,
                GrandTotal: data.GrandTotal,
                GrandTotalRounded: data.GrandTotalRounded,
                TotalItems: data.TotalItems,
                TotalDiscount: data.TotalDiscount,
                remotePayInfo: data.RemotePayInfo || null,
                isPreauth: data.IsPreauth || false,
                prepayInfo: data.PrepaymentPayInfo || null,
                RoundingAmount: data.RoundingAmount,
                TipAmount: data.TipAmount,
            });

            if (UserStore.getState().selectedLocation.ApplyLoyaltyPointsAutomatically) {
                let clearCartOnAutoApply = false;

                GuestActions.loadFullGuest(guest_id, clearCartOnAutoApply);
            }
        });
    },

    calcUserCartTotal: (guestId, shipmentId, isCheckout = false) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CART_TOTAL_CALCULATING,
        });
        let formData = UserStore.getApiData();
        formData.AcctId = guestId;
        formData.ShipmentId = shipmentId;
        formData.Timestamp = Date.now();
        formData.UpdateCache = UserStore.getState().selectedLocation.UseCartDisplay;
        formData.IsCheckout = isCheckout;

        return AjaxPromises.POST(CartEndPoints.CALC_CART_TOTAL, formData).then(resp => {
            if(!resp.Result) {
                NotificationActions.error('Error calculating cart total');
                AppDispatcher.dispatch({
                    actionType: ActionTypes.CART_TOTAL_FAILED,
                });
                return;
            }
            const { Data: data } = resp;

            let selectedGuest = GuestStore.selectedGuestId();
            if(selectedGuest != guestId) {
                return;
            }

            AppDispatcher.dispatch({
                actionType: ActionTypes.CART_TOTAL_CALCULATED,
                appliedDiscounts: data.Discounts || [],
                appliedFeesDonations: data.FeesDonations || [],
                loyalty: data.Loyalty ? data.Loyalty.AppliedLoyaltyPoints : 0,
                SubTotal: data.SubTotal,
                TotalDiscountAndLoyalty: data.TotalDiscountAndLoyalty,
                Tax: data.Tax,
                FeesAndDonations: data.FeesAndDonations,
                GrandTotal: data.GrandTotal,
                GrandTotalRounded: data.GrandTotalRounded,
                TotalItems: data.TotalItems,
                TotalDiscount: data.TotalDiscount,
                RoundingAmount: data.RoundingAmount,
                payment: data.Payment ? data.Payment : { ElectronicAmount: null, ElectronicType: null },
                TipAmount: data.TipAmount,
            });

            if (UserStore.getState().selectedLocation.ApplyLoyaltyPointsAutomatically) {
                let clearCartOnAutoApply = false;

                GuestActions.loadFullGuest(guestId, clearCartOnAutoApply);
            }
        });
    },

    loadRemotePayStatus: (shipmentId) => {
        return AjaxPromises.POST(CartEndPoints.LOAD_REMOTE_PAY_STATUS, { ShipmentId: shipmentId }).then(resp => {
            if(!resp.Result) {
                console.error(resp);
                NotificationActions.error('Error loading remote pay status');
                return;
            }
            
            AppDispatcher.dispatch({
                actionType: ActionTypes.REMOTE_PAY_STATUS_LOADED,
                remotePayInfo: resp.Data || null,
            });
        });
    },

    loadPreOrders:(formData) => {

        PosCartApi.loadPreOrders(
            formData
        ).then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.PRE_ORDERS_LOADED,
                data: res.Data
            });
        });
    },

    loadUserAllotment:(shipment_id) => {
        let formData        = UserStore.getApiData();
        formData.ShipmentId = shipment_id;

        let promise = PosCartApi.loadUserAllotment(formData);

        promise.then(res => {

            AppDispatcher.dispatch({
                actionType: ActionTypes.ALLOTMENT_LOADED,
                data: res.Data,
            });
        });
    },

    addItemToCart: (item, guest, count) => {
        if (UserStore.getState().selectedLocation.RestrictMinorSales
                && guest.PurchasingForMinor && !item.AllowSaleToMinor) {
            PosCartActions.notification('Cannot sell this item to a minor', 'error', true, true);
            return;
        }

        let self            = this;
        let formData        = UserStore.getApiData();
        formData.ProductId  = item.ProductId;
        formData.PackageItemId = item.PackageItemId;
        formData.SerialNo   = item.SerialNo.toString();
        formData.Weight     = 0;
        formData.shipmentId = guest.ShipmentId;
        formData.Cnt        = parseInt(count);

        const allotment = PosCartStore.getAllotment(guest, item.MasterCategory);
        let AvailOz = (allotment.total - allotment.cart - allotment.used).toFixed(2);
        formData.AcctId = guest.Guest_id;
        formData.PatientType = guest.PatientType;
        formData.AvailOz    = AvailOz;
        formData.Grouping   = 'No';
        formData.UsingDaysSupply = UserStore.getState().selectedLocation.ShowDaysSupplyCalculator;

        formData.UnitPrice = item.UnitPrice;
        formData.RecUnitPrice = item.RecUnitPrice;
        formData.DiscountAmt = item.hasOwnProperty('DiscountAmount') ? item.DiscountAmount : 0;
        formData.RunAutoPrice = UserStore.getState().selectedLocation.RunAutoPrice;
        formData.RunAutoDiscount = UserStore.getState().selectedLocation.RunAutoDiscount;
        formData.LoyaltyAsDiscount = UserStore.getState().selectedLocation.LoyaltyAsDiscount;
        formData.QuantityItem = item.WgtCnt === 'Qty' || item.ProductType === 'Qty';
        
        AppDispatcher.dispatch({
            actionType: ActionTypes.START_LOAD
        });

        PosCartApi.addItemToCart(formData).then(res => {

            AppDispatcher.dispatch({
                actionType: ActionTypes.END_LOAD
            });

            PosCartActions.notification(
                `${res.Message}, ${res.IntegrationMessage || ''}`,
                res.Result ? 'success' : 'error',
                res.Result ? false : true,
                res.Result ? false : true
            );

            // TODO :: Should not return success if item does not get added to cart
            if (res.Result) {
                if(!!res.Data) {
                    if(res.Data.length > 0) {
                        item.InventoryId = res.Data[0].InvId;
                        item.PackageItemId = res.Data[0].PackageItemId;
                    }
                    if(res.Data.hasOwnProperty('InvId')) {
                        item.InventoryId = res.Data.InvId;
                    }
                    if (res.Data.hasOwnProperty('PackageItemId')) {
                        item.PackageItemId = res.Data.PackageItemId;
                    }
                }
                for (let i=0; i<count; i++) {
                    PosCartActions.autoPrintLabel(item, guest);
                }
            }
            
            PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);

            PosActions.productSearch(UserStore.getApiData(), guest.Guest_id);
        }).catch(err => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.END_LOAD
            });
        });
    },

    addBulkItemToCart: (formData, guest, item) => {
        formData.RunAutoPrice = UserStore.getState().selectedLocation.RunAutoPrice;
        formData.RunAutoDiscount = UserStore.getState().selectedLocation.RunAutoDiscount;
        formData.LoyaltyAsDiscount = UserStore.getState().selectedLocation.LoyaltyAsDiscount;
        formData.UsingDaysSupply = UserStore.getState().selectedLocation.ShowDaysSupplyCalculator;
        formData.PatientType = guest.PatientType;
        formData.AcctId = guest.Guest_id;
        formData.RecUnitPrice = item.RecUnitPrice;
        AppDispatcher.dispatch({
            actionType: ActionTypes.START_LOAD
        });

        PosCartApi.addBulkItemToCart(formData).then(res => {

            AppDispatcher.dispatch({
                actionType: ActionTypes.END_LOAD
            });

            if(!res.Result) {
                PosCartActions.notification(
                    `${res.Message}, ${res.IntegrationMessage || ''}`,
                    'error',
                );
            }
            if (res.Data && res.Data.length > 0) {
                if (res.Data[0] != 0 && !!res.Result) { // success
                    item.InventoryId = res.Data[0];
                    PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
                    PosCartActions.autoPrintLabel(item, guest);
                    NotificationActions.success(res.Message);
                } else {
                    PosCartActions.notification(
                        res.Message,
                        'error',
                    );
                }
            }

            PosActions.productSearch(UserStore.getApiData(), guest.Guest_id);
        }).catch(err => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.END_LOAD
            });
        });
    },

    clearUserCart:(guest) => {
        let formData = UserStore.getApiData();
        formData.ShipmentId = guest.ShipmentId;

        let promise = PosCartApi.clearUserCart(formData);

        promise.then(res => {
            ga('send', 'event', 'Clear User Cart', res.Result ? 'Success' : 'Error', res.Message);

            if (res.Result) {
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
            }

            PosCartActions.notification(res.Message, res.Result ? 'success' : 'error');
            PosActions.productSearch(UserStore.getApiData(), guest.Guest_id);
        });
    },

    removeItemFromCart:(item, guest, count, refresh) => {
        let self            = this;
        let formData        = UserStore.getApiData();
        formData.SerialNo   = item.SerialNo;
        formData.ProductId  = item.ProductId.toString();
        formData.InventoryId = item.WgtCnt === 'Qty' ? null : item.InventoryId;
        formData.shipmentId = guest.ShipmentId;
        formData.Cnt        = count;
        formData.LoyaltyAsDiscount = UserStore.getState().selectedLocation.LoyaltyAsDiscount;
        formData.RunAutoPrice = UserStore.getState().selectedLocation.RunAutoPrice;
        formData.AcctId     = guest.Guest_id;
        formData.PatientType = guest.PatientType;

        AppDispatcher.dispatch({
            actionType: ActionTypes.START_LOAD
        });

        let promise = PosCartApi.removeItemFromCart(formData);
        promise.then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.END_LOAD
            });

            PosCartActions.notification(res.Message, res.Result ? 'success' : 'error');

            PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);

            PosActions.productSearch(UserStore.getApiData(), guest.Guest_id);
            
            
        }).catch(err => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.END_LOAD
            });
        });
        return promise;
    },

    editItem:(formData, guest) => {
        let promise = PosCartApi.editItem(formData);
        promise.then(res => {
            PosCartActions.notification(res.Message, res.Result ? 'success' : 'error');

            if (res.Result) {
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
            }

            PosActions.productSearch(UserStore.getApiData(), guest.Guest_id);
        });
        return promise;
    },

    removeMultipleAppliedDiscounts:(guest, inv_ids, refresh) => {
        let promiseArr = []
        for(let inv_id of inv_ids) {
            let formData        = UserStore.getApiData();
            formData.InvId      = inv_id;
            formData.ShipmentId = guest.ShipmentId;
            formData.LoyaltyAsDiscount = UserStore.getState().selectedLocation.LoyaltyAsDiscount;
            
            promiseArr.push(PosCartApi.removeAppliedDiscount(formData));
        }

        RSVP.all(promiseArr).then(res => {
            PosCartActions.notification(res[0].Message, res[0].Result ? 'success' : 'error');
            if (res[0].Result && refresh) {
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
            }
        })
    },

    removeAppliedDiscount:(guest, inv_id, refresh) => {
        let self            = this;

        let formData        = UserStore.getApiData();
        formData.InvId      = inv_id;
        formData.ShipmentId = guest.ShipmentId;
        formData.LoyaltyAsDiscount = UserStore.getState().selectedLocation.LoyaltyAsDiscount;

        let promise = PosCartApi.removeAppliedDiscount(formData);
        promise.then(res => {

            PosCartActions.notification(res.Message, res.Result ? 'success' : 'error');

            if (res.Result && refresh) {
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
                // PosActions.loadAppliedDiscounts(guest.ShipmentId);
            }
        });
    },

    removeAppliedFeeDonation:(guest, data) => {
        let formData        = UserStore.getApiData();
        formData.ShipmentId = guest.ShipmentId;
        formData.AppliedFeeDonationId = data.AppliedFeeDonationId;

        let promise = PosCartApi.removeAppliedFeeDonation(formData);
        promise.then(res => {

            PosCartActions.notification('Fee/Donation successfully removed', res.Result ? 'success' : 'error');

            if (res.Result) {
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
            }
        });
    },

    applyDiscountByCode:(guest, discountCode) => {
        let formData = UserStore.getApiData();
        formData.ShipmentId = guest.ShipmentId;
        formData.DiscountCode = discountCode;
        formData.CustomerId = guest.Guest_id;

        let promise = PosCartApi.applyDiscountByCode(formData);
        promise.then(res => {
            if (res.Result) {
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
                PosCartActions.notification('Discount applied successfully', 'success');
            } else {
                PosCartActions.notification(res.Message, 'error');
            }
        });
    },

    autoDiscount:(guest, inventoryId) => {
        let formData = UserStore.getApiData();
        formData.ShipmentId = guest.ShipmentId;
        formData.InventoryId = inventoryId;
        formData.AcctId = guest.Guest_id;
        return AjaxPromises.POST('api/v2/cart/auto-discount', formData).then(res => {
            if(!res.Result) {
                NotificationActions.error(`Error running auto discounts. ${res.Message}`);
            }
        });
    },

    netaAutoPrice:(guest, notify) => {
        let formData = UserStore.getApiData();
        formData.ShipmentId = guest.ShipmentId;

        let promise = PosCartApi.netaAutoPrice(formData);
        promise.then(res => {
            if (notify) {
                PosCartActions.notification(res.Message, res.Result ? 'success' : 'error');
            }

            if (res.Result) {
                if (UserStore.getState().selectedLocation.RunAutoDiscount) {
                    PosCartActions.netaAutoDiscount(guest);
                }
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
            }
            else
                $('#pos-header-neta-price').css({ 'backgroundColor' : '#ebebeb' });
        });
        return promise;
    },

    netaAutoDiscount:(guest) => {
        let formData = UserStore.getApiData();
        formData.guest_id = guest.Guest_id;

        let promise = PosCartApi.loadCartDetails(formData);
        promise.then(res => {

            let promiseArr = [];
            for (let i=0; i<res.Data.length; i++) {
                let formData = UserStore.getApiData();
                formData.ShipmentId = guest.ShipmentId;
                formData.InvId = res.Data[i].OrderNo;

                promiseArr.push(PosCartApi.netaAutoDiscount(formData));
            }

            RSVP.all(promiseArr).then(res => {
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
            });
        });
    },

    autoPrintLabel(item, guest) {
        if (!PosStore.getState().autoPrintLabels) {
            return;
        }

        if(item.AutoPrintLabel === false) { //don't short circuit if it's undefined
            return;
        }

        PrintActions.printLabel(item, guest, false, false, true);
    },

    notification(message, type, sticky, fullscreen) {
        setTimeout(() => {
            NotificationActions.addNotification({
                type : type,
                body : message,
                fullscreen : fullscreen,
                sticky : sticky
            });
        }, 100);
    }
}

export default PosCartActions;



// WEBPACK FOOTER //
// ./ui_src/app/actions/PosCartActions.jsx